import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";

import "./config/env";
// Firebase Performance Monitoring (Firebase Analytics was replaced by GA4).
import "./analytics/firebase";

import { captureFirstTouch } from "./analytics/attribution";
import { router } from "./router";

// Before the first render: reads UTMs / the marketing-site handoff and cleans `ft` from the URL.
captureFirstTouch();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
